// @ts-strict-ignore
import { usePractitionerQuery } from "@clinic/shared/data/queries/PractitionerQuery/Practitioner.query";
import { useFSWholesaleEnabled } from "@clinic/shared/hooks/useFSWholesaleEnabled/useFSWholesaleEnabled";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";

const useCertCaptureEnabled = (skipWholesaleCheck?: boolean): boolean => {
  const fsWholesaleEnabled = useFSWholesaleEnabled() || skipWholesaleCheck;
  const { role } = useSharedGlobalConfig();
  const { data } = usePractitionerQuery();

  if (role === "practitioner") {
    if (data?.currentPractitioner) {
      return fsWholesaleEnabled && data?.currentPractitioner?.isStoreOwner;
    }
  }

  return fsWholesaleEnabled && role === "clerk";
};

export { useCertCaptureEnabled };
